// extracted by mini-css-extract-plugin
module.exports = {"container":"user-list_container__qoU5T"};